import React from 'react';
import { useReveal } from '../lib/useReveal';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="premium" className="bg-brand-alternate py-8 md:py-10 px-4 sm:px-6 border-t border-brand-border-soft" style={{
    scrollMarginTop: '80px'
  }} data-id="element-35">
      <div className="container mx-auto max-w-5xl" data-id="element-36">
        <div ref={ref1} className={`reveal text-center mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-2 leading-tight text-brand-heading" data-id="element-38">
            ELEGÍ TU MEGAPACK
          </h2>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch ${vis2 ? 'is-visible' : ''}`} data-id="element-39">
          <div className="relative rounded-[20px] p-5 sm:p-8 flex flex-col bg-brand-footer border-2 border-brand-accent shadow-premium" data-id="element-40">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-cta text-white text-[10px] font-bold px-4 py-1 rounded-[6px] shadow-lg z-20 whitespace-nowrap tracking-wider" data-id="element-41">
              ⭐ RECOMENDADO
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-42">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-2 leading-tight" data-id="element-43">
                🏆 MEGAPACK CÓDIGO FÉRTIL + KIT RITUAL PREMIUM ⭐
              </h3>
              <p className="text-brand-border-soft font-bold text-sm mb-4" data-id="element-44">
                6 Tomos + 6 Bonos + Kit Ritual Premium de 60 páginas
              </p>
              <div className="bg-white/10 border border-white/20 rounded-lg p-4 mb-6 text-left" data-id="element-45">
                <p className="text-brand-footer-text text-sm leading-snug" data-id="element-46">
                  <span className="font-bold text-white" data-id="element-47">Ideal para:</span>{' '}
                  Vivir el método completo con un sistema de implementación
                  guiada de 21 días, planner holístico imprimible y rituales
                  lunares avanzados.
                </p>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-48">
                <span className="text-white/50 line-through text-lg font-bold" data-id="element-49">
                  $89.000
                </span>
                <p className="text-4xl sm:text-5xl font-extrabold text-white leading-none mt-1" data-id="element-50">
                  $27.990 <span className="text-xl text-white/80" data-id="element-51">ARS</span>
                </p>
              </div>
            </div>

            <a href="https://pagos.academiaholisticaargentina.com/cart/48480180371673:1" target="_blank" rel="noopener noreferrer" className="w-full block py-4 rounded-full text-white font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-brand-cta hover:bg-brand-cta-hover shadow-medium hover:shadow-lg hover:-translate-y-1 mt-auto" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-52">
              → QUIERO EL MEGAPACK + KIT PREMIUM
            </a>
          </div>

          <div className="relative rounded-[20px] p-5 sm:p-8 flex flex-col bg-brand-card border border-brand-border-soft shadow-soft" data-id="element-53">
            <div className="text-center mb-6 mt-2" data-id="element-54">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-brand-heading mb-2 leading-tight" data-id="element-55">
                📘 MEGAPACK CÓDIGO FÉRTIL
              </h3>
              <p className="text-brand-subheading font-bold text-sm mb-4" data-id="element-56">
                6 Tomos + 6 Bonos
              </p>
              <div className="bg-brand-primary border border-brand-border-soft rounded-lg p-4 mb-6 text-left" data-id="element-57">
                <p className="text-brand-body text-sm leading-snug" data-id="element-58">
                  <span className="font-bold text-brand-heading" data-id="element-59">
                    Ideal para:
                  </span>{' '}
                  Conocer el método completo, transformar el bienestar femenino
                  y empezar a aplicar desde el primer día.
                </p>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-60">
                <span className="text-brand-soft line-through text-lg font-bold" data-id="element-61">
                  $69.000
                </span>
                <p className="text-4xl sm:text-5xl font-extrabold text-brand-heading leading-none mt-1" data-id="element-62">
                  $19.990{' '}
                  <span className="text-xl text-brand-subheading" data-id="element-63">ARS</span>
                </p>
              </div>
            </div>

            <a href="https://pagos.academiaholisticaargentina.com/cart/48480179650777:1" target="_blank" rel="noopener noreferrer" className="w-full block py-4 rounded-full text-brand-heading font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-white hover:bg-brand-primary border border-brand-border-soft hover:border-brand-accent hover:-translate-y-1 mt-auto" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-64">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </div>
      </div>
    </section>;
}